import { z } from "zod";

import { sectionItemTypeEnum } from "../../enums/sectionItemTypeEnum";
import { sectionTypeEnum } from "../../enums/sectionTypeEnum";
import { sectionItemSchema } from "./sectionItemSchema";

export const sectionSchema = z.object({
  action_link: z.string().optional().nullable(),
  action_title: z.string().optional().nullable(),
  action_icon: z
    .enum([
      "plus",
      "plus_outline",
      "plus_filled",
      "edit",
      "more",
      "info",
      "support",
      "share",
      "pin_outline",
      "pin_filled",
      "favorite_outline",
      "favorite_filled",
      "favorite_off",
      "routine",
      "download",
      "time",
      "pray_outline",
      "pray_filled",
      "reflection",
    ])
    .optional()
    .nullable(),
  id: z.number(),
  is_first_large: z.boolean().optional(),
  language: z.string().optional(),
  page_id: z.number().optional(),
  title: z.string().nullable(),
  type: sectionTypeEnum,
  item_type: sectionItemTypeEnum,
  items: z.array(sectionItemSchema),
  title_link_accessibility: z.string().optional().nullable(),
  title_link: z.string().optional().nullable(),
});

export type Section = z.infer<typeof sectionSchema>;
